// extracted by mini-css-extract-plugin
module.exports = {"QuestionTitle":"QuestionTitle_QuestionTitle__3s88U","Title":"QuestionTitle_Title__WTXgg","Description":"QuestionTitle_Description__3vzT2"};